import React, { Component } from 'react';
import { Field } from 'redux-form';
import partial from 'lodash/partial';
import truncate from 'lodash/truncate';
import classnames from 'classnames';
import { TextAreaField, RadioButtonField, SelectField } from 'common/components/form_fields';
import isEmail from 'sane-email-validation';
import { WEIGHT_OPTIONS, WEIGHT_NEUTRAL } from 'presentations/constants';

export default class ParticipantsField extends Component {
  constructor(props) {
    super(props);
    this.add = this.add.bind(this);
    this.remove = this.remove.bind(this);
    this.changeEmail = this.changeEmail.bind(this);
    this.state = { email: '', invalid: false };
  }

  changeEmail(e) {
    const email = e.target.value;
    const invalid = !isEmail(email);
    this.setState({ email, invalid });
  }

  remove(idx, e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.fields.remove(idx);
  }

  add(e) {
    e.preventDefault();
    e.stopPropagation();

    const { email } = this.state;
    if (!isEmail(email)) {
      this.setState({ invalid: true });
      return;
    }

    this.props.fields.push({ email, weight: WEIGHT_NEUTRAL });
    this.setState({ email: '', invalid: false });
  }

  renderEmail(props) {
    return (<span>
      <span className="hide-for-large">{ truncate(props.input.value, { length: 20 }) }</span>
      <span className="show-for-large">{ truncate(props.input.value, { length: 40 }) }</span>
    </span>);
  }

  render() {
    const { fields, weightVotes } = this.props;
    const { email, invalid } = this.state;

    const groupClasses = classnames('form-group', { error: invalid });
    const controlClasses = classnames('form-control', { filled: email });

    return (<div className="participants-field">
      <div className={groupClasses}>
        <input onChange={this.changeEmail} value={email} type="email" name="email"
          className={controlClasses} />
        <span className="bar" />
        <label htmlFor="email" className="form-label animate">Email</label>
        { invalid && <span className="error-msg">Please enter a valid email</span> }
      </div>
      <div>
        <button type="button" className="btn btn-md btn-secondary" onClick={this.add}>Add</button>
      </div>
      { weightVotes && fields.length > 0 && <div className="row participant-row">
        <div className="columns small-8 large-10" />
        <div className="columns small-4 small-offset-8 large-4 large-offset-0">
          <strong>Vote counts:</strong>
        </div>
      </div> }
      { fields.map((user, index) => (
        <div key={`new-participant-${index}`} className="row participant-row">
          <div className="small-8 large-10 columns">
            <Field
              name={`${user}.email`}
              component={this.renderEmail}
            />
          </div>
          <div className="small-6 large-4 columns weight-option">
            { weightVotes && <Field
              name={`${user}.weight`}
              component={SelectField}
              options={WEIGHT_OPTIONS}
            /> }
          </div>
          <div className="small-2 columns">
            <button onClick={partial(this.remove, index)} className="fa fa-times-circle" />
          </div>
        </div>
      )) }
    </div>
   );
  }
}



// WEBPACK FOOTER //
// ./presentations/components/participants_field.jsx